import React from "react";
import Button from "material-ui/Button";
import Paper from "material-ui/Paper";
import Card from "material-ui/Card";
import Tabs, { Tab } from "material-ui/Tabs";
import { withStyles } from "material-ui/styles";
import CustomerInfoCardContainer from "containers/CustomerDetail/CustomerInfoCard";
import CustomerAdminCardContainer from "containers/CustomerDetail/CustomerAdminCardContainer";
import SurveyTableContainer from "containers/CustomerDetail/SurveyTableContainer";
import BackButton from "components/BackButton";

import CustomerModalContair from "containers/CustomerDetail/CustomerInfoCard/Modal";
import ModalContainer from "containers/CustomerDetail/CustomerAdminModalContainer";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  header: {
    display: "flex",
    marginBottom: 10
  },
  title: {
    margin: 0
  },
  main: {
    padding: 20
  },
  surveyAttrEditBtn: {
    marginRight: 10
  },
  infoCard: {
    minHeight: 300
  },
  tabs: {
    backgroundColor: "#fafafa",
    borderBottom: "1px solid lightgray"
  },
  tabLabel: {
    fontSize: "1.1rem"
  },
  tabRootInherit: {
    color: "inherit",
    opacity: 1
  },
  tabRootInheritSelected: {
    fontWeight: 700
  },
  clear: {
    clear: "both"
  }
});

class CustomerDetail extends React.Component {
  componentWillMount() {
    this.props.fetchCustomerDetail();
  }

  componentWillUnmount() {
    this.props.initCustomerDetail();
  }

  render() {
    const { classes, customerDetail, changeTab } = this.props;
    const { customer, customerAdmins, tabIndex } = customerDetail || {};

    return (
      this.props.customerDetail && (
        <div>
          <CustomerModalContair
            fetchCustomerDetail={this.props.fetchCustomerDetail}
          />
          <ModalContainer
            fetchCustomerDetail={this.props.fetchCustomerDetail}
          />
          <Paper className={classes.container}>
            <div className={classes.header}>
              <h2 className={classes.title}>顧客詳細</h2>
              <BackButton link="/customer_list" />

              <Button
                raised
                className={classes.surveyAttrEditBtn}
                onClick={() => this.props.setupAttr()}
              >
                アンケート属性設定
              </Button>
            </div>

            <div className={classes.main}>
              <Card className={classes.infoCard}>
                <Tabs
                  value={tabIndex}
                  indicatorColor="secondary"
                  fullWidth
                  onChange={changeTab}
                  className={classes.tabs}
                >
                  <Tab
                    label="顧客基本情報"
                    classes={{
                      label: classes.tabLabel,
                      rootInherit: classes.tabRootInherit,
                      rootInheritSelected: classes.tabRootInheritSelected
                    }}
                  />
                  <Tab
                    label="顧客担当者"
                    classes={{
                      label: classes.tabLabel,
                      rootInherit: classes.tabRootInherit,
                      rootInheritSelected: classes.tabRootInheritSelected
                    }}
                  />
                </Tabs>

                {tabIndex === 0 && (
                  <CustomerInfoCardContainer customer={customer} />
                )}
                {tabIndex === 1 && (
                  <CustomerAdminCardContainer
                    customerAdmins={customerAdmins}
                    fetchCustomerDetail={this.props.fetchCustomerDetail}
                  />
                )}
                <div className={classes.clear} />
              </Card>

              <div className={classes.clear} />

              <SurveyTableContainer />
            </div>
          </Paper>
        </div>
      )
    );
  }
}

export default withStyles(styles)(CustomerDetail);



// WEBPACK FOOTER //
// ./src/components/CustomerDetail/index.jsx